// extracted by mini-css-extract-plugin
export default {"list":"Categories_list__0rAV4","name":"Categories_name__96l4W","description":"Categories_description__a9NLM"};